export interface IBackgroundCheckInfo {
  readonly candidateID: string;
  readonly invitationID: string;
  readonly invitationLink: string;
  readonly expiredDate: Date;
  readonly consentDate: Date;
  readonly notificationDate: Date;
  readonly status: BackgroundCheckStatusEnum;
}

export enum BackgroundCheckStatusEnum {
  NotStarted = 'not started',
  Pending = 'pending',
  Consider = 'consider',
  Clear = 'clear',
  Failed = 'failed',
}
